// Comprehensive district program data for Tamil Nadu
// Contains education, food, and technology programs for each district

export const districtPrograms = {
    chennai: {
        id: 'chennai',
        name: 'Chennai',
        tamilName: 'சென்னை',
        programs: {
            education: [
                'Night School - 13 centers',
                'Computer Training - 7 centers',
                'Free Study Materials',
                'Academic Tutoring',
                'Scholarship Program',
                'Value-Based Education'
            ],
            food: [
                'Daily lunch for 50 elders',
                'Dinner for 15 students'
            ],
            technology: [
                'Computer training for 150+ students',
                'MS Office certification'
            ]
        }
    },
    madurai: {
        id: 'madurai',
        name: 'Madurai',
        tamilName: 'மதுரை',
        programs: {
            education: [
                'Night School - 2 centers',
                'Free Study Materials',
                'Academic Tutoring',
                'Scholarship Program',
                'Value-Based Education'
            ],
            food: [
                'Daily meals for 40 elders',
                'Student meal program'
            ],
            technology: [
                'Computer literacy program',
                'Digital skills training'
            ]
        }
    },
    coimbatore: {
        id: 'coimbatore',
        name: 'Coimbatore',
        tamilName: 'கோயம்புத்தூர்',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Academic Tutoring',
                'Value-Based Education'
            ],
            food: [
                'Elder care meals',
                'Student nutrition program'
            ],
            technology: [
                'Computer training',
                'Digital literacy'
            ]
        }
    },
    tiruchirappalli: {
        id: 'tiruchirappalli',
        name: 'Tiruchirappalli',
        tamilName: 'திருச்சிராப்பள்ளி',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Academic Tutoring',
                'Scholarship Program'
            ],
            food: [
                'Daily lunch program',
                'Student meals'
            ],
            technology: [
                'Basic computer education'
            ]
        }
    },
    salem: {
        id: 'salem',
        name: 'Salem',
        tamilName: 'சேலம்',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Academic Tutoring',
                'Value-Based Education'
            ],
            food: [
                'Elder meal program'
            ],
            technology: [
                'Computer training'
            ]
        }
    },
    tirunelveli: {
        id: 'tirunelveli',
        name: 'Tirunelveli',
        tamilName: 'திருநெல்வேலி',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Academic Tutoring',
                'Scholarship Program'
            ],
            food: [
                'Daily meals for elders'
            ],
            technology: []
        }
    },
    erode: {
        id: 'erode',
        name: 'Erode',
        tamilName: 'ஈரோடு',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Academic Tutoring'
            ],
            food: [
                'Food distribution program'
            ],
            technology: [
                'Computer training'
            ]
        }
    },
    vellore: {
        id: 'vellore',
        name: 'Vellore',
        tamilName: 'வேலூர்',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Academic Tutoring',
                'Value-Based Education'
            ],
            food: [
                'Meal program for students'
            ],
            technology: [
                'Digital literacy program'
            ]
        }
    },
    thoothukudi: {
        id: 'thoothukudi',
        name: 'Thoothukudi',
        tamilName: 'தூத்துக்குடி',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Academic Tutoring'
            ],
            food: [
                'Elder care meals'
            ],
            technology: []
        }
    },
    dindigul: {
        id: 'dindigul',
        name: 'Dindigul',
        tamilName: 'திண்டுக்கல்',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Academic Tutoring',
                'Scholarship Program'
            ],
            food: [
                'Meal distribution'
            ],
            technology: []
        }
    },
    thanjavur: {
        id: 'thanjavur',
        name: 'Thanjavur',
        tamilName: 'தஞ்சாவூர்',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Academic Tutoring',
                'Value-Based Education'
            ],
            food: [
                'Elder meal program'
            ],
            technology: []
        }
    },
    kanyakumari: {
        id: 'kanyakumari',
        name: 'Kanyakumari',
        tamilName: 'கன்னியாகுமரி',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Scholarship Program'
            ],
            food: [],
            technology: []
        }
    },
    tiruvannamalai: {
        id: 'tiruvannamalai',
        name: 'Tiruvannamalai',
        tamilName: 'திருவண்ணாமலை',
        programs: {
            education: [
                'Night School',
                'Free Study Materials',
                'Academic Tutoring',
                'Value-Based Education'
            ],
            food: [],
            technology: []
        }
    },
    kanchipuram: {
        id: 'kanchipuram',
        name: 'Kanchipuram',
        tamilName: 'காஞ்சிபுரம்',
        programs: {
            education: [
                'Computer Training - 8 centers',
                'Free Study Materials',
                'Academic Tutoring'
            ],
            food: [],
            technology: [
                'Computer training centers'
            ]
        }
    },
    ranipet: {
        id: 'ranipet',
        name: 'Ranipet',
        tamilName: 'ராணிப்பேட்டை',
        programs: {
            education: [
                'Computer Training - 3 centers',
                'Academic Tutoring'
            ],
            food: [],
            technology: [
                'Computer education'
            ]
        }
    },
    villupuram: {
        id: 'villupuram',
        name: 'Villupuram',
        tamilName: 'விழுப்புரம்',
        programs: {
            education: [
                'Computer Training',
                'Free Study Materials',
                'Academic Tutoring'
            ],
            food: [],
            technology: [
                'Digital skills training'
            ]
        }
    },
    cuddalore: {
        id: 'cuddalore',
        name: 'Cuddalore',
        tamilName: 'கடலூர்',
        programs: {
            education: [
                'Computer Training',
                'Free Study Materials',
                'Academic Tutoring'
            ],
            food: [],
            technology: [
                'Computer literacy'
            ]
        }
    },
    tiruvallur: {
        id: 'tiruvallur',
        name: 'Tiruvallur',
        tamilName: 'திருவள்ளூர்',
        programs: {
            education: [
                'Computer Training - 12 centers',
                'Academic Tutoring'
            ],
            food: [],
            technology: [
                'Computer training centers'
            ]
        }
    },
    chengalpattu: {
        id: 'chengalpattu',
        name: 'Chengalpattu',
        tamilName: 'செங்கல்பட்டு',
        programs: {
            education: [
                'Computer Training',
                'Academic Tutoring'
            ],
            food: [],
            technology: [
                'Digital education'
            ]
        }
    },
    virudhunagar: {
        id: 'virudhunagar',
        name: 'Virudhunagar',
        tamilName: 'விருதுநகர்',
        programs: {
            education: [
                'Free Study Materials',
                'Academic Tutoring',
                'Value-Based Education'
            ],
            food: [],
            technology: []
        }
    },
    // Add more districts with their basic presence
    krishnagiri: {
        id: 'krishnagiri',
        name: 'Krishnagiri',
        tamilName: 'கிருஷ்ணகிரி',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    dharmapuri: {
        id: 'dharmapuri',
        name: 'Dharmapuri',
        tamilName: 'தர்மபுரி',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    karur: {
        id: 'karur',
        name: 'Karur',
        tamilName: 'கரூர்',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    namakkal: {
        id: 'namakkal',
        name: 'Namakkal',
        tamilName: 'நாமக்கல்',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    theni: {
        id: 'theni',
        name: 'Theni',
        tamilName: 'தேனி',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    ramanathapuram: {
        id: 'ramanathapuram',
        name: 'Ramanathapuram',
        tamilName: 'ராமநாதபுரம்',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    sivaganga: {
        id: 'sivaganga',
        name: 'Sivaganga',
        tamilName: 'சிவகங்கை',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    pudukkottai: {
        id: 'pudukkottai',
        name: 'Pudukkottai',
        tamilName: 'புதுக்கோட்டை',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    tiruppur: {
        id: 'tiruppur',
        name: 'Tiruppur',
        tamilName: 'திருப்பூர்',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    nagapattinam: {
        id: 'nagapattinam',
        name: 'Nagapattinam',
        tamilName: 'நாகப்பட்டினம்',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    ariyalur: {
        id: 'ariyalur',
        name: 'Ariyalur',
        tamilName: 'அரியலூர்',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    perambalur: {
        id: 'perambalur',
        name: 'Perambalur',
        tamilName: 'பெரம்பலூர்',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    nilgiris: {
        id: 'nilgiris',
        name: 'Nilgiris',
        tamilName: 'நீலகிரி',
        programs: {
            education: ['Free Study Materials', 'Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    tiruvarur: {
        id: 'tiruvarur',
        name: 'Tiruvarur',
        tamilName: 'திருவாரூர்',
        programs: {
            education: ['Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    tirupattur: {
        id: 'tirupattur',
        name: 'Tirupattur',
        tamilName: 'திருப்பத்தூர்',
        programs: {
            education: ['Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    tenkasi: {
        id: 'tenkasi',
        name: 'Tenkasi',
        tamilName: 'தென்காசி',
        programs: {
            education: ['Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    kallakurichi: {
        id: 'kallakurichi',
        name: 'Kallakurichi',
        tamilName: 'கள்ளக்குறிச்சி',
        programs: {
            education: ['Academic Tutoring'],
            food: [],
            technology: []
        }
    },
    mayiladuthurai: {
        id: 'mayiladuthurai',
        name: 'Mayiladuthurai',
        tamilName: 'மயிலாடுதுறை',
        programs: {
            education: ['Academic Tutoring'],
            food: [],
            technology: []
        }
    }
};

// Helper function to check if a district has any programs
export const hasPrograms = (districtId) => {
    const district = districtPrograms[districtId];
    if (!district) return false;
    
    const { education = [], food = [], technology = [] } = district.programs;
    return education.length > 0 || food.length > 0 || technology.length > 0;
};

// Helper function to get program count for a district
export const getProgramCount = (districtId) => {
    const district = districtPrograms[districtId];
    if (!district) return 0;
    
    const { education = [], food = [], technology = [] } = district.programs;
    return education.length + food.length + technology.length;
};
